import globals from '../../../globals/communityGlobals';

export const featureAccesses = {
  dashboard: [globals.applicationFeatureAccesses.canAccessDashboard],
  dailyPlanning: [globals.applicationFeatureAccesses.showDailyPlanningView],
  planning: [
    globals.applicationFeatureAccesses.canAccessCliniciansView,
    globals.applicationFeatureAccesses.canAllocateWork,
  ],
  visitActuals: [globals.applicationFeatureAccesses.canActualisePatientVisits],
  reports: [globals.applicationFeatureAccesses.canAccessReports],
  patients: [
    globals.applicationFeatureAccesses.canAddPatients,
    globals.applicationFeatureAccesses.canEditPatients,
    globals.applicationFeatureAccesses.canAddReferrals,
    globals.applicationFeatureAccesses.canEditReferrals,
    globals.applicationFeatureAccesses.canAddTreatments,
    globals.applicationFeatureAccesses.canEditTreatments,
  ],
  nonPatientActivities: [globals.applicationFeatureAccesses.canSetUpTeamMeetings],
  admin: [globals.applicationFeatureAccesses.canTriggerSync],
  integration: [
    globals.applicationFeatureAccesses.enableIntegrationMode,
    globals.applicationFeatureAccesses.canTriggerSync,
  ],
  isInIntegrationMode: [globals.applicationFeatureAccesses.enableIntegrationMode],
};
